import PdfThumbnail from './PdfThumbnail';

export default PdfThumbnail;
